var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { Modal } from '../../../../ts/helpers/Modal';
export class Dashboard extends Component {
    constructor(isDebugEnabled = false) {
        super('Dashboard', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.btn-remove').on('click', (event, button) => __awaiter(this, void 0, void 0, function* () {
                event.preventDefault();
                button.addClass('loading');
                yield Modal.show('delete');
                button.removeClass('loading');
                $('#assessment-title').text(button.data('title'));
                $('.btn-confirm-delete').on('click', (event) => __awaiter(this, void 0, void 0, function* () {
                    window.location.href = button.attr('href');
                }));
            }));
            this.success();
        });
    }
}
